import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const QUERY = gql`
  query GetCampaignMetric(
    $requestId: ID!
    $campaignIds: [String!]!
    $dataSource: PerformanceCenterDataSource!
  ) {
    getCampaignMetric(requestId: $requestId, campaignIds: $campaignIds, dataSource: $dataSource) {
      totalCopyCount
    }
  }
`;

export const getPerformanceCenterCampaignMetric = ({ requestId, campaignIds, dataSource }) => {
  return apolloClient
    .query({
      query: QUERY,
      variables: {
        requestId,
        campaignIds,
        dataSource,
      },
      fetchPolicy: 'no-cache',
    })
    .then(({ data }) => getSingleProp(data));
};
